import { Chip } from '@mui/material'
import DoneIcon from '@mui/icons-material/Done'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import { Box, Typography } from 'components/Material/index'
import useTextStyles from 'styles/useTextStyles'
import { ChipData } from 'types/filters'

type Props = {
  appliedFilters: ChipData[]
  onRemove: (filter: ChipData) => void
  clearAllFilter: () => void
}
export const AppliedFilterChips = ({ appliedFilters, onRemove, clearAllFilter }: Props) => {
  return (
    <>
      <Box className="flex flex-wrap justify-center gap-2 max-w-[390px] pt-5">
        {appliedFilters.map((filter) => (
          <Box key={filter.key} className="flex w-fit">
            <Chip
              title={filter.label || ''}
              avatar={<DoneIcon className="text-[#1D192B] w-[18px] h-[18px]" />}
              label={filter.label || ''}
              deleteIcon={<HighlightOffIcon className="text-[#1D192B] w-[18px] h-[18px]" />}
              onDelete={() => onRemove(filter)}
              sx={{ ...useTextStyles.labelLarge, backgroundColor: '#E3EAFC', borderRadius: '8px' }}
            />
          </Box>
        ))}
      </Box>
      <Box className="mt-5 flex justify-center cursor-pointer" onClick={() => clearAllFilter()}>
        <Typography
          title="Limpar todos os filtros"
          sx={{ ...useTextStyles.labelLarge }}
          className="text-blue-bb"
        >
          Limpar todos os filtros
        </Typography>
      </Box>
    </>
  )
}
